"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackedBars = void 0;
var React = require("react");
var react_chartjs_2_1 = require("react-chartjs-2");
var chart_1 = require("../../theme/chart");
var StackedBars = /** @class */ (function (_super) {
    __extends(StackedBars, _super);
    function StackedBars() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StackedBars.prototype.render = function () {
        var _a = this.props, height = _a.height, width = _a.width, data = _a.data, _b = _a.legendFontSize, legendFontSize = _b === void 0 ? 12 : _b;
        return (React.createElement("div", null,
            React.createElement(react_chartjs_2_1.Bar, { height: height, width: width, data: {
                    datasets: data.map(function (item) { return ({
                        label: item.label,
                        backgroundColor: [item.backgroundColor],
                        borderColor: ['#FFFFFF'],
                        borderWidth: [2],
                        data: [item.count],
                        hoverBackgroundColor: [item.backgroundColor]
                    }); })
                }, options: {
                    responsive: true,
                    tooltips: chart_1.tooltipOptions,
                    layout: {
                        padding: 0
                    },
                    scales: {
                        xAxes: [
                            {
                                display: false,
                                stacked: true,
                                barThickness: 50
                            }
                        ],
                        yAxes: [
                            {
                                display: false,
                                stacked: true,
                                barThickness: 50
                            }
                        ]
                    },
                    legend: {
                        onClick: function () {
                            /* void */
                        },
                        labels: {
                            usePointStyle: true,
                            fontSize: legendFontSize,
                            fontStyle: 'bold',
                            fontFamily: 'museo-sans, sans-serif'
                        },
                        display: true,
                        position: 'left'
                    }
                } })));
    };
    return StackedBars;
}(React.Component));
exports.StackedBars = StackedBars;
//# sourceMappingURL=index.js.map